<template>
  <div class="knowhow-list-container">
    <h1 class="knowhow-page-title">서베이지 블로그</h1>
    <p class="knowhow-page-sub">설문 설계부터 응답 분석까지, 리서처에게 필요한 이야기를 정리했어요.</p>

    <div class="knowhow-post-list">
      <router-link
        class="knowhow-post-item"
        v-for="tip in tips"
        :key="tip.id"
        :to="`/knowhowcontent/${tip.id}`"
      >
        <img class="knowhow-post-thumb" :src="tip.thumb" :alt="tip.title">
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KnowHowContainer',

  data() {
    return {
      tips: [
        { id: 1, eyebrow: '서베이지의 EASY한 서베이 꿀팁 #1', title: '설문조사 제작할 때 고려해야 할 6가지 요소', thumb: require('@/assets/knowhow/one/main-1.png') },
        { id: 2, eyebrow: '서베이지의 EASY한 서베이 꿀팁 #2', title: '설문조사를 진행할 만한 주제는 어떤 것일까?', thumb: require('@/assets/knowhow/one/surveytips2thumbnail.png') },
        { id: 3, eyebrow: '서베이지의 EASY한 서베이 꿀팁 #3', title: '무료 온라인 설문 툴 비교: 구글폼 VS 네이버폼', thumb: require('@/assets/knowhow/one/surveytips3thumbnail.png') },
        { id: 4, eyebrow: '서베이지의 EASY한 서베이 꿀팁 #4', title: '설문 배포 시 유용한 꿀팁 4가지', thumb: require('@/assets/knowhow/one/surveytips4thumbnail.png') },
        { id: 5, eyebrow: '서베이지의 EASY한 서베이 꿀팁 #5', title: '설문조사 Do & Don’t', thumb: require('@/assets/knowhow/one/surveytips5thumbnail.png') },
        { id: 6, eyebrow: '서베이지의 EASY한 서베이 꿀팁 #6', title: '설문조사 데이터 분석&그래프 만들기(feat. 구글폼)', thumb: require('@/assets/knowhow/one/surveytips6thumbnail.png') },
        { id: 7, eyebrow: '서베이지의 EASY한 서베이 꿀팁 #7', title: '설문조사 설명란에 꼭 포함해야 할 4가지', thumb: require('@/assets/knowhow/one/surveytips7thumbnail.png') },
        { id: 8, eyebrow: '서베이지의 EASY한 서베이 꿀팁 #8', title: '구글폼 질문 유형 9가지 총정리!', thumb: require('@/assets/knowhow/one/surveytips8thumbnail.png') }
      ]
    }
  }
}
</script>

<style scoped>
.knowhow-list-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 40px 24px 80px;
  font-family: var(--font-sans);
}

.knowhow-page-title {
  margin: 0 0 var(--space-3) 0;
  font-size: 34px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}

.knowhow-page-sub {
  margin: 0 0 var(--space-8) 0;
  font-size: 16px;
  color: var(--text-muted);
  text-align: left;
}

.knowhow-post-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 320px));
  gap: 28px;
  justify-content: start;
}

.knowhow-post-item {
  display: block;
  border-radius: var(--radius-md);
  overflow: hidden;
  background-color: var(--bg-sunken);
  box-shadow: var(--shadow-sm);
}

.knowhow-post-item:hover {
  box-shadow: var(--shadow-md);
}

.knowhow-post-thumb {
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
}

@media (max-width: 560px) {
  .knowhow-page-title {
    font-size: 24px;
  }

  .knowhow-post-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}
</style>
